import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import styles from "./bpmnModelItem/BpmnModelItem.module.scss";
import appContext from "../../../../context/appContext";
import moment from "moment";
import http from "../../../../services/api/utilities/http";

const BpmnModelItem = ({ id, title, created, description, file, redirectTo, refetch }) => {

  const context = useContext(appContext);
  const history = useHistory();

  const handleShowBpmn = () => {
       context.dispatch({type:'set_bpmn_id',value:id})
    if (redirectTo === 'bpmn') {
      history.push(`/show-bpmn?url=${file}`);
      context.handleAddTab(101, 'Show Bpmn Model', `/show-bpmn?url=${file}`);
    } else if (redirectTo === 'conformanceChecking') {
      history.push(`/conformance-checking`);
      context.handleAddTab(102, 'Show Conformance Checking', `/conformance-checking`);
      context.handleConformanceCheckingData({title, created: moment(created).format("DD MMM YYYY"), description, file});
    }
  }

  const handleDelete = (e) => {
    e.stopPropagation()
    let r = window.confirm("Are You Sure?");
    if (r === true) {
      let token = localStorage.getItem('token');
      http.delete(`process_mining/bpmn/${id}`,
        {
          headers: {
            Authorization: 'Bearer ' + token
          }
        })
        .then(res => {
          refetch()
        })
        .catch(err => {
          console.log(err.response);
        })
    }
  }

  return (
    <div onClick={handleShowBpmn} className={[styles.BpmnModelItemWrapper, 'col-sm-4 col-md-4 col-lg-3 col-xl-2'].join(' ')}>
      <div className={styles.bpmnModelItem}>
        {/*<div className={[styles.preview, 'd-flex text-center justify-content-center align-items-center'].join(' ')}>*/}
        {/*  <span>Preview</span>*/}
        {/*</div>*/}
        <div>
          <div className={styles.title}>
            <span>{ title || "BPMN Model" }</span>
          </div>
          <div className={styles.date}>
            <span>{ moment(created).format("DD MMM YYYY") }</span>
          </div>
          <div className={styles.description}>
            {(description !== null && description !== undefined && description !== '') ? <p>{ description }</p> : <div className={[styles.emptyDesc, 'd-flex align-items-center justify-content-center'].join(' ')}>Description</div> }
          </div>
          <div className={styles.icons}>
            <span>
              <i>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9.57693 2.32422H6.4611C3.8986 2.32422 2.29193 4.13839 2.29193 6.70672V13.6351C2.29193 16.2034 3.8911 18.0176 6.4611 18.0176H13.8144C16.3853 18.0176 17.9844 16.2034 17.9844 13.6351V10.2784" stroke="#8A0FFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M7.35652 9.10074L13.584 2.87324C14.3599 2.09824 15.6174 2.09824 16.3932 2.87324L17.4074 3.88741C18.1832 4.66324 18.1832 5.92158 17.4074 6.69658L11.1499 12.9541C10.8107 13.2932 10.3507 13.4841 9.87069 13.4841H6.74902L6.82736 10.3341C6.83902 9.87074 7.02819 9.42908 7.35652 9.10074Z" stroke="#8A0FFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M12.6377 3.83545L16.4427 7.64045" stroke="#8A0FFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </i>
            </span>
            <span onClick={handleDelete}>
              <i>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16.1041 7.89014C16.1041 7.89014 15.6516 13.5026 15.3891 15.8668C15.2641 16.996 14.5666 17.6576 13.4241 17.6785C11.2499 17.7176 9.07326 17.7201 6.89993 17.6743C5.80076 17.6518 5.11493 16.9818 4.99243 15.8726C4.72826 13.4876 4.27826 7.89014 4.27826 7.89014" stroke="#8A0FFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M17.2569 5.19975H3.12518" stroke="#8A0FFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M14.5339 5.19974C13.8797 5.19974 13.3164 4.73724 13.188 4.0964L12.9855 3.08307C12.8605 2.61557 12.4372 2.29224 11.9547 2.29224H8.42719C7.94469 2.29224 7.52136 2.61557 7.39636 3.08307L7.19386 4.0964C7.06552 4.73724 6.50219 5.19974 5.84802 5.19974" stroke="#8A0FFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </i>
            </span>
          </div>
        </div>
      </div>
    </div>
  )
};

export default BpmnModelItem;